import { type SvgIconProps } from '@common/components/svgs/props';

function IconSettings(
  { size = 24, color = 'scheme-feedback-text-color', ...rest }: Readonly<SvgIconProps>,
) {
  return (
    <svg
      {...rest}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="svg-Settings"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.75592 2H14.1641L14.6402 5.5276C15.2077 5.76442 15.7368 6.07473 16.2175 6.45136L19.5179 5.09235L21.7242 8.90777L18.9011 11.0819C18.9405 11.3843 18.96 11.6912 18.96 12C18.96 12.3088 18.9405 12.6157 18.9011 12.9181L21.7242 15.0922L19.5179 18.9077L16.2175 17.5486C15.7368 17.9253 15.2077 18.2356 14.6402 18.4724L14.1641 22H9.75592L9.2798 18.4724C8.71231 18.2356 8.18322 17.9253 7.70257 17.5486L4.40211 18.9077L2.1958 15.0922L5.01893 12.9181C4.97949 12.6157 4.96002 12.3088 4.96002 12C4.96002 11.6912 4.97949 11.3843 5.01893 11.0819L2.1958 8.90777L4.40211 5.09235L7.70257 6.45136C8.18322 6.07473 8.71231 5.76442 9.2798 5.5276L9.75592 2ZM11.5041 4L11.0957 7.02598L10.4864 7.21506C9.76372 7.43935 9.11852 7.82016 8.58023 8.33361L8.11007 8.78207L5.25792 7.60765L4.80423 8.39223L7.2297 10.2601L7.08403 10.8865C7.00219 11.2384 6.96002 11.6122 6.96002 12C6.96002 12.3878 7.00219 12.7616 7.08403 13.1135L7.2297 13.7399L4.80423 15.6078L5.25792 16.3923L8.11007 15.2179L8.58023 15.6664C9.11852 16.1798 9.76372 16.5606 10.4864 16.7849L11.0957 16.974L11.5041 20H12.4159L12.8243 16.974L13.4336 16.7849C14.1563 16.5606 14.8015 16.1798 15.3398 15.6664L15.81 15.2179L18.6621 16.3923L19.1158 15.6078L16.6903 13.7399L16.836 13.1135C16.9178 12.7616 16.96 12.3878 16.96 12C16.96 11.6122 16.9178 11.2384 16.836 10.8865L16.6903 10.2601L19.1158 8.39223L18.6621 7.60765L15.81 8.78207L15.3398 8.33361C14.8015 7.82016 14.1563 7.43935 13.4336 7.21506L12.8243 7.02598L12.4159 4H11.5041ZM11.96 11C11.4123 11 10.96 11.4523 10.96 12C10.96 12.5477 11.4123 13 11.96 13C12.5077 13 12.96 12.5477 12.96 12C12.96 11.4523 12.5077 11 11.96 11ZM8.96002 12C8.96002 10.3477 10.3077 9 11.96 9C13.6123 9 14.96 10.3477 14.96 12C14.96 13.6523 13.6123 15 11.96 15C10.3077 15 8.96002 13.6523 8.96002 12Z"
        fill={`var(--${color})`}
      />
    </svg>
  );
}

IconSettings.displayName = 'Settings';

export default IconSettings;
